module.exports = __webpack_public_path__ + "static/media/gen_img46.1a6dde66.png";